<template>
  <div class="auth-wrapper auth-v1 forgot px-2">
    <div class="py-2 col-12 col-md-6">
      <h1 style="font-size: 36px;" class="mb-2 colorWhite">忘記密碼？</h1>
      <h4 class="colorWhite">
        請輸入您的電郵並按下發送驗證碼按鈕，我們將向您發送驗證碼
      </h4>
      <div style="font-size: 16px;" class="colorWhite">如您沒有電郵，請聯絡我們 (852) 2479 8967</div>
    </div>
    <div class="auth-inner col-12 col-md-6 py-2">
      <div class="auth-content">
        <!-- Login v1 -->
        <b-card class="mb-0 py-1 px-2">
          <b-link class="brand-logo">
            <h2 class="brand-text">
              <!-- {{ company }} -->
            </h2>
          </b-link>

          <!-- form -->
          <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
            <b-overlay
              :show="loading"
              spinner-variant="primary"
              spinner-type="grow"
              spinner-small
              rounded="sm"
            >
            <b-form class="auth-form" @submit.prevent="handleSubmit(resetPasswordForm)">
             
                <validation-provider
                    #default="{ errors }"
                    name="此欄"
                    rules="required|email"
                  >
                    <b-form-group class="required mt-1" label="電郵：">
                      <b-input-group>
                        <b-form-input
                          id="forgot-password-email"
                          v-model="resetData.email"
                          :state="errors.length > 0 ? false : null"
                          name="forgot-password-email"
                          placeholder="輸入電郵"
                        />
                        <b-input-group-append is-text>
                          <b-button
                            variant="primary"
                            class="p-50"
                            @click="sendVertificationCode"
                          >
                            發送驗證碼
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>

                  <validation-provider
                    #default="{ errors }"
                    name="密碼"
                    vid="password"
                    rules="required"
                  >
                    <b-form-group class="required mt-1" label="密碼：">
                      <b-form-input
                        id="password"
                        type="password"
                        placeholder="輸入密碼"
                        v-model="resetData.password"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider
                    #default="{ errors }"
                    name="確認密碼"
                    vid="c_password"
                    rules="required"
                  >
                    <b-form-group class="required" label="確認密碼：">
                      <b-form-input
                        id="c_password"
                        type="password"
                        placeholder="輸入確認密碼"
                        v-model="resetData.c_password"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                  
                  <validation-provider
                    #default="{ errors }"
                    name="驗證碼"
                    vid="vaildate"
                    rules="required"
                  >
                    <b-form-group class="required" label="驗證碼：">
                      <b-form-input
                        id="vaildate"
                        placeholder="輸入驗證碼"
                        v-model="resetData.vertification_code"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                <div>
                  <b-button type="submit" variant="primary" block class="">
                    提交
                  </b-button>
                </div>
              </b-form>
            </b-overlay>
          </validation-observer>
          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ArrowLeftIcon" /> 返回登入頁
            </b-link>
          </p>
        </b-card>
        <!-- /Login v1 -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import zh_CN from 'vee-validate/dist/locale/zh_CN.json';
localize('zh_cn',zh_CN)
import formValidation from "@core/comp-functions/forms/form-validation";
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BCard, BRow, BCol, BLink, BOverlay, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { ref, watch } from "@vue/composition-api";

import axiosIns from "@/libs/axios";


export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCard,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      email,
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
    }
  },
  computed: {
    imgUrl() {
      return this.sideImg
    },
  },
  methods: {
    resetPasswordForm() {
        this.loading = true
        axiosIns.post("/resetpassword_with_code",this.resetData).then((response)=>{
          this.$swal({
              text: response.data.message,
              icon: "success",
              confirmButtonText: "確定",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              showClass: {
                popup: "animate__animated animate__bounceIn",
              },
              buttonsStyling: false,
          });
          this.$router.replace("/login");
          this.loading = false
        }).catch((err) => {
          console.log(err);
          this.loading = false
          this.$swal({
              text: err.response.data.message,
              icon: "error",
              confirmButtonText: "確定",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              showClass: {
                popup: "animate__animated animate__bounceIn",
              },
              buttonsStyling: false,
          });
        });
    },
    sendVertificationCode(){
      this.loading = true
      axiosIns.post("/sendVertificationCode",{email:this.resetData.email}).then((response)=>{
        this.$swal({
            text: response.data.message,
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
        });
      this.loading = false
      }).catch((err) => {
        console.log(err);
        this.loading = false
        this.$swal({
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
        });
      });
    }
  },
  setup(){
    const resetData = ref({})
    const loading = ref(false);
    const resetInvoiceData = () => {
      resetData.value = {
        email: '',
        password: '',
        c_password: '',
        vertification_code: '',
      };
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetInvoiceData);

    return {
      resetData,
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
#forgot-password-email{
  border-radius: 0.357rem 0 0 0.357rem;
}
.auth-form{
  label{
    font-size: 14px;
  }
}
.input-group-text{
  padding: 0rem 0.5rem;
}
</style>
